import {Checkbox} from "components";
import {getName} from "helpers/string";
import CheckboxList from "mapx-components/Inputs/CheckboxList";
import React from "react";
import {TCity, TCountry, TRegion, TState} from "../types";

type CityItemProps = {
	city: TCity;
	state: TState;
	region: TRegion;
	country: TCountry;
	expanded: boolean;
	disabled: boolean;
	treeIndex: number;
	isSelected: boolean;
	onToggle: () => void;
};

const CityItem: React.FC<CityItemProps> = ({
	city,
	expanded,
	disabled,
	treeIndex,
	isSelected,
	onToggle,
}) => {
	return (
		<CheckboxList.AccordionChildrenContent
			expanded={expanded}
			key={city.id}
			childrenExpanded={false}
			handleExpandClick={() => undefined}
			hasChildren={false}
			treeIndex={treeIndex}
			item={city}
		>
			<Checkbox
				borderColor="#0C5850"
				isChecked={isSelected}
				key={city.id}
				label={getName(city.name)}
				onChange={onToggle}
				value={getName(city.name)}
				disabled={disabled}
			/>
		</CheckboxList.AccordionChildrenContent>
	);
};

export default CityItem;
